/**
 * Thai date formatter utility
 * Formats dates to Thai format: "4 ส.ค. 68, 13:00 น."
 */

const thaiMonthsShort = [
  'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
  'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
];

/**
 * Format date to Thai format
 * @param dateInput - Date string, Date object, or timestamp
 * @returns Formatted Thai date string (e.g., "4 ส.ค. 68, 13:00 น.")
 */
export const formatThaiDate = (dateInput: string | Date | number): string => {
  try {
    const date = new Date(dateInput);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '-';
    }

    const day = date.getDate();
    const month = thaiMonthsShort[date.getMonth()];
    const year = (date.getFullYear() + 543) % 100; // Convert to Buddhist era and get last 2 digits
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day} ${month} ${year}, ${hours}:${minutes} น.`;
  } catch (error) {
    console.error('Error formatting Thai date:', error);
    return '-';
  }
};

/**
 * Format date to Thai format without time
 * @param dateInput - Date string, Date object, or timestamp
 * @returns Formatted Thai date string without time (e.g., "4 ส.ค. 68")
 */
export const formatThaiDateOnly = (dateInput: string | Date | number): string => {
  try {
    const date = new Date(dateInput);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '-';
    }

    const day = date.getDate();
    const month = thaiMonthsShort[date.getMonth()];
    const year = (date.getFullYear() + 543) % 100; // Convert to Buddhist era and get last 2 digits

    return `${day} ${month} ${year}`;
  } catch (error) {
    console.error('Error formatting Thai date:', error);
    return '-';
  }
};